import { PageComponentId, navigateTo } from '@wix/business-manager-api';
import { ModuleRegistry } from 'react-module-container';
import { crmHomeMethodNames } from '../../../../crm-actions';

export interface FinanceOption {
  id: string;
  action: Function;
}

export const financeSectionCardOptions: FinanceOption[] = [
  {
    id: 'priceQuotes',
    action: () => {
      navigateTo({
        pageComponentId: PageComponentId.PriceQuotes,
        viewId: 'price-quotes',
        contextData: {
          appState: `create`,
          referrer: 'crmHome',
        },
      });
    },
  },
  {
    id: 'payments',
    action: () => {
      navigateTo({
        pageComponentId: PageComponentId.Engage,
        contextData: {
          referrer: 'crmHome',
        },
      });
    },
  },
  {
    id: 'paymentForms',
    action: () => {
      ModuleRegistry.invoke(crmHomeMethodNames.addForm);
    },
  },
];
